import { useState } from "react";
import { toast } from "sonner";
import { Check, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";

export function McpCodeBlock({ code }: { code: string }) {
	const [copied, setCopied] = useState(false);

	async function copy() {
		try {
			await navigator.clipboard.writeText(code);
			setCopied(true);
			setTimeout(() => setCopied(false), 2000);
		} catch {
			toast.error("Failed to copy. Select the text and copy manually.");
		}
	}

	return (
		<div className="relative rounded-md border border-border bg-muted-subtle">
			<pre className="overflow-x-auto p-3 pr-20 text-[11px] leading-relaxed text-foreground">
				<code>{code}</code>
			</pre>
			<Button type="button" size="xs" variant="outline" onClick={copy} className="absolute right-2 top-2">
				{copied ? <Check className="h-3 w-3" /> : <Copy className="h-3 w-3" />}
				{copied ? "Copied" : "Copy"}
			</Button>
		</div>
	);
}
